export default "__VITE_ASSET__qB5hfrWB__"